import React from 'react';
import { useAppState } from '../../State.tsx';
import { getFlowNode } from '../../Flow.ts';

import './Header.less';

const Header = () => {
  const { currentNodeId, fitAssistantBikesData, setShowFitAssistant, goBack, canGoBack } = useAppState();

  const translations = fitAssistantBikesData?.Translations;
  const currentNode = getFlowNode(currentNodeId);
  const cmsStep = fitAssistantBikesData?.Steps?.find((stepData) => stepData.Parameter === currentNode.cmsParameter);

  const onBackClick = () => {
    goBack();
  };

  const onClose = () => {
    setShowFitAssistant(false);
  };

  return (
    <div className="fit-assistant-modal-header flex-column px-6 px-lg-9 mt-6">
      <div className="buttons w-100">
        <button className={`btn fit-guide-modal-back ${!canGoBack ? 'invisible' : ''}`} onClick={onBackClick}>
          <span>
            <i className="le-icon-arrow"></i>
          </span>
          <span className="sr-only">{translations?.back}</span>
        </button>
        <button className="btn hide-fit-guide-modal" onClick={onClose}>
          <span>
            <i className="le-icon-x"></i>
          </span>
          <span className="sr-only">{translations?.close}</span>
        </button>
      </div>
      <div className="info d-flex flex-column w-100">
        <span className="selection mt-6 mb-3 display-block">{translations?.pannierFitAssistant}</span>
        <h3 className="heading3 header mb-0">{cmsStep?.Headline}</h3>
      </div>
    </div>
  );
};

export default Header;
